import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { apiPost, setAccessToken } from "../api";
import { useAuth } from "../auth";
import type { ConsoleUser } from "../types";

interface SessionResponse {
  tokens: { access_token: string };
  user: ConsoleUser;
}

export default function SsoExchange() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { setSession } = useAuth();
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const token = params.get("token");
    if (!token) {
      setErr("This sign-in link is missing its token.");
      return;
    }
    (async () => {
      try {
        const data = await apiPost<SessionResponse>("/auth/sso-exchange", { token });
        if (cancelled) return;
        setAccessToken(data.tokens.access_token);
        setSession(data.user);
        nav("/", { replace: true });
      } catch {
        if (!cancelled) setErr("This sign-in link is invalid or has expired.");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [params, nav, setSession]);

  return (
    <div className="auth-screen">
      <div className="auth-card">
        {err ? (
          <>
            <p className="err">{err}</p>
            <a className="auth-hint" href="/login">
              Sign in with a password instead
            </a>
          </>
        ) : (
          <p className="signing">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
